import {
  BooleanParam,
  DateParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { DocumentSearchOrder } from '@/globalTypes';
import {
  DocumentStatusParam,
  DocumentTypeParam,
  DocumentsSearchOrderParam,
} from '@/utils/query/params';

export const queryParams = {
  after: StringParam,
  before: StringParam,
  first: withDefault(NumberParam, 20),
  last: NumberParam,
  desc: withDefault(BooleanParam, true),
  from: DateParam,
  to: DateParam,
  orderBy: withDefault(
    DocumentsSearchOrderParam,
    DocumentSearchOrder.uploadedAt,
  ),
  documentType: DocumentTypeParam,
  status: DocumentStatusParam,
};
